export default "__VITE_ASSET__ByGHCF4G__"